import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router"
import { ROUTER } from "~/common/router"
import { generatePvKey, slsLogger } from "~/common/analytics"

type ChannelCallbackProps = {
  channel: "doudian" | "douyin"
}

// 抖店 / 抖音渠道落地页：补齐 spm、上报 PV 后回到首页
export const ChannelCallback = ({ channel }: ChannelCallbackProps) => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (!searchParams.get("spm")) {
      const params = new URLSearchParams(searchParams)
      params.set("spm", channel)
      setSearchParams(params, { replace: true })
    }

    slsLogger.trackPage(
      window.location.pathname + window.location.search,
      generatePvKey(),
      { reason: `${channel}_cb` },
    )
    navigate(ROUTER.HOME, { replace: true })
  }, [channel, navigate, searchParams, setSearchParams])

  return null
}
